import React from 'react';
import { Alert, Button } from 'react-bootstrap';

interface Props {
    show: boolean;
    isAppMode: boolean;
    onRefresh: () => void;
    onDismiss: () => void;
}

function AppUpdateBanner({ show, isAppMode, onRefresh, onDismiss }: Props) {
    if (!show) return null;

    return (
        <Alert
            variant="info"
            className="mb-0 rounded-0 border-0 app-update-banner"
            role="alert"
        >
            <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 px-1">
                <span className="small">
                    {isAppMode
                        ? 'A new version of the app is available. Refreshing shortly…'
                        : 'A new version is available. Refresh to get the latest tee times and booking fixes.'}
                </span>
                <div className="d-flex gap-2 flex-shrink-0">
                    <Button variant="primary" size="sm" type="button" onClick={onRefresh}>
                        Refresh now
                    </Button>
                    {!isAppMode && (
                        <Button variant="outline-secondary" size="sm" type="button" onClick={onDismiss}>
                            Later
                        </Button>
                    )}
                </div>
            </div>
        </Alert>
    );
}

export default AppUpdateBanner;
